/**
 * @generated SignedSource<<3f41d704216ff95ed1168c68ea5a52ca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CareType = "CAREER_COACHING" | "COACHING" | "HYBRID_CARE" | "THERAPEUTIC_STRUCTURED" | "THERAPEUTIC_UNSTRUCTURED";
export type GuestStatusEnum = "ACTIVE" | "MOVED_TO_PERSONAL_PLAN" | "PENDING_INVITATION" | "PENDING_REVOKE" | "REVOKED";
export type OrganisationPlanRenewalPeriod = "MONTHLY" | "YEARLY";
export type OrganisationPlanStatus = "ACTIVE" | "ENDED" | "NOT_STARTED";
export type OrganisationPlanType = "FULL" | "TRIAL" | "WORKSHOP_ONLY";
export type ServiceTypes = "ASK_A_THERAPIST" | "DROP_IN" | "HYBRID_CARE" | "MANAGER_ONE_TO_ONE" | "OLIVA_AT_WORK" | "OLIVA_AT_WORK_ADMIN_ONLY" | "PRIVATE_WORKSHOP" | "TALK" | "TEST" | "TEXT_THERAPY" | "THERAPY" | "WORKSHOP";
export type SlackIntegrationMode = "BOT" | "USER";
export type SurveyStatus = "COMPLETED" | "PENDING" | "SKIPPED";
export type UserGenderEnum = "FEMALE" | "MALE" | "NON_BINARY" | "OTHER" | "PREFER_NOT_TO_SAY" | "UNSURE";
export type UserRoleEnum = "ADMIN" | "CLINICAL_SUPERVISOR" | "EMPLOYEE" | "EXTERNAL_CLINICAL_SUPERVISOR" | "IMPERSONATOR" | "MANAGER" | "MENTOR" | "MHP" | "ORGANISATION_ADMIN" | "UNKNOWN";
export type UserSpeakingLanguages = "ar" | "bg" | "bs" | "cmn" | "cnr" | "da" | "de" | "el" | "en" | "es" | "et" | "fi" | "fil" | "fr" | "he" | "hi" | "hr" | "hu" | "id" | "it" | "ja" | "lt" | "lv" | "ms" | "nl" | "no" | "pl" | "pt" | "ro" | "ru" | "sk" | "sq" | "sr" | "sv" | "th" | "tr" | "uk" | "ur" | "yue";
export type UserStatusEnum = "ACTIVE" | "DELETED" | "SUSPENDED";
export type UserDataContextQuery$variables = Record<PropertyKey, never>;
export type UserDataContextQuery$data = {
  readonly viewer: {
    readonly apartment?: string | null | undefined;
    readonly careTypesAvailable?: ReadonlyArray<{
      readonly careType: CareType;
      readonly isRecommended: boolean;
    }>;
    readonly city?: string | null | undefined;
    readonly country?: string | null | undefined;
    readonly createdAt?: string;
    readonly dateOfBirth?: string | null | undefined;
    readonly detectedCountryCode?: string | null | undefined;
    readonly deviceTokens?: ReadonlyArray<{
      readonly token: string;
    }>;
    readonly dnaSessionPriceString?: string | null | undefined;
    readonly email?: string;
    readonly ethnicity?: string | null | undefined;
    readonly gender?: UserGenderEnum | null | undefined;
    readonly guestInformation?: {
      readonly dependeeEmail: string;
      readonly dependeeName: string;
      readonly dependeeSurname: string;
      readonly status: GuestStatusEnum;
      readonly switchToPersonalPlanScheduledFor: string | null | undefined;
    } | null | undefined;
    readonly hasActiveCoaching?: boolean;
    readonly hasActiveTherapy?: boolean;
    readonly hasBookedSessions?: boolean;
    readonly hasCompletedOnboarding?: boolean;
    readonly hasCompletedWorkOnboarding?: boolean;
    readonly hasEnrolledMfa?: boolean;
    readonly hasRequiredSlackScopes?: boolean;
    readonly id?: string;
    readonly isSlackPaired?: boolean;
    readonly languages?: ReadonlyArray<UserSpeakingLanguages> | null | undefined;
    readonly lastInsightFeedbackDate?: string | null | undefined;
    readonly lastThreadFeedbackDate?: string | null | undefined;
    readonly marketingOptIn?: boolean;
    readonly maxNumberOfServices?: {
      readonly hasCoachingOnlyAllocation: boolean;
      readonly hasSplitAllocation: boolean;
      readonly hasTherapyOnlyAllocation: boolean;
      readonly hasUnlimitedCoachingSessions: boolean;
      readonly hasUnlimitedSessions: boolean;
      readonly hasUnlimitedTherapySessions: boolean;
      readonly numberOfCoachingSessions: number | null | undefined;
      readonly numberOfOneToOneSessions: number | null | undefined;
      readonly numberOfPublicClasses: number | null | undefined;
      readonly numberOfSessionsForActiveCare: number | null | undefined;
      readonly numberOfTherapySessions: number | null | undefined;
      readonly numberOfWorkshops: number | null | undefined;
    };
    readonly name?: string;
    readonly organisation?: {
      readonly hasTeamSessionsOnly: boolean | null | undefined;
      readonly id: string;
      readonly isWorkOnlyOrganisation: boolean | null | undefined;
      readonly name: string;
      readonly plan: {
        readonly accessCareerCoaching: boolean | null | undefined;
        readonly endDate: string | null | undefined;
        readonly hasDNAChargeEnabled: boolean;
        readonly hasPAYGEnabled: boolean;
        readonly maxNumberOfGuestsPerUser: number | null | undefined;
        readonly maxNumberOfOneToOneSessions: number | null | undefined;
        readonly maxNumberOfOneToOneSessionsForGuests: number | null | undefined;
        readonly maxNumberOfPublicClasses: number | null | undefined;
        readonly maxNumberOfWorkshops: number | null | undefined;
        readonly monthlyOneToOneSessionLimit: number | null | undefined;
        readonly name: string | null | undefined;
        readonly oneToOneRenewalDate: string | null | undefined;
        readonly oneToOneSessionsForGuestsRenewalPeriod: OrganisationPlanRenewalPeriod | null | undefined;
        readonly oneToOneSessionsRenewalPeriod: OrganisationPlanRenewalPeriod | null | undefined;
        readonly publicClassesRenewalDate: string | null | undefined;
        readonly services: ReadonlyArray<ServiceTypes>;
        readonly status: OrganisationPlanStatus;
        readonly type: OrganisationPlanType;
        readonly yearlyOneToOneSessionLimit: number | null | undefined;
      } | null | undefined;
      readonly settings: {
        readonly crisisSupportEnabled: boolean;
      } | null | undefined;
      readonly teams: ReadonlyArray<string>;
    } | null | undefined;
    readonly organisationGroup?: {
      readonly organisations: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
      }>;
    } | null | undefined;
    readonly organisationTeam?: string | null | undefined;
    readonly paymentServicePaymentMethodId?: string | null | undefined;
    readonly personalEmail?: string | null | undefined;
    readonly phone?: string;
    readonly preferredLanguage?: string | null | undefined;
    readonly profileImage?: string | null | undefined;
    readonly region?: string | null | undefined;
    readonly religion?: string | null | undefined;
    readonly role?: ReadonlyArray<UserRoleEnum>;
    readonly sessionAllowance?: {
      readonly activeCareSessions: number | null | undefined;
      readonly coachingSessions: number | null | undefined;
      readonly oneToOneSessions: number | null | undefined;
      readonly organisationPeriodAllowanceLimits: {
        readonly monthlyLimit: number | null | undefined;
        readonly monthlyRemaining: number | null | undefined;
        readonly monthlyResetDate: string | null | undefined;
        readonly monthlyUsed: number;
        readonly yearlyLimit: number | null | undefined;
        readonly yearlyRemaining: number | null | undefined;
        readonly yearlyResetDate: string | null | undefined;
        readonly yearlyUsed: number;
      } | null | undefined;
      readonly publicClassSessions: number | null | undefined;
      readonly therapySessions: number | null | undefined;
      readonly workshopSessions: number | null | undefined;
    };
    readonly sessionPriceString?: string | null | undefined;
    readonly settings?: {
      readonly allowDataProcessing: boolean | null | undefined;
      readonly hasAcceptedTermsAndConditions: boolean;
      readonly hasGivenDataProcessingConsent: boolean;
      readonly hasGivenSessionSummarisationConsent: boolean;
    } | null | undefined;
    readonly sexualOrientation?: string | null | undefined;
    readonly slackIntegrationId?: string | null | undefined;
    readonly slackIntegrationMode?: SlackIntegrationMode | null | undefined;
    readonly slackTeamId?: string | null | undefined;
    readonly slackUserId?: string | null | undefined;
    readonly status?: UserStatusEnum;
    readonly streetAddress?: string | null | undefined;
    readonly surname?: string;
    readonly surveyEmployeeNPSPendingSubmissionId?: string | null | undefined;
    readonly surveyEmployeePostSessionSatisfaction?: {
      readonly professional: {
        readonly clinicalProfile: {
          readonly image: string | null | undefined;
        } | null | undefined;
        readonly name: string;
      } | null | undefined;
      readonly sessionId: string;
    } | null | undefined;
    readonly surveyProfessionalNPSPendingSubmissionId?: string | null | undefined;
    readonly timezone?: string | null | undefined;
    readonly verificationHash?: string;
    readonly vipTrialSurveySubmissions?: {
      readonly followUpSurveySubmission: {
        readonly status: SurveyStatus;
        readonly submissionId: string;
      } | null | undefined;
      readonly gettingStartedSurveySubmission: {
        readonly status: SurveyStatus;
        readonly submissionId: string;
      } | null | undefined;
    } | null | undefined;
    readonly zipCode?: string | null | undefined;
  };
};
export type UserDataContextQuery = {
  response: UserDataContextQuery$data;
  variables: UserDataContextQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "detectedCountryCode",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sessionPriceString",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dnaSessionPriceString",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastThreadFeedbackDate",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastInsightFeedbackDate",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "GuestInformation",
  "kind": "LinkedField",
  "name": "guestInformation",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dependeeName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dependeeSurname",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dependeeEmail",
      "storageKey": null
    },
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "switchToPersonalPlanScheduledFor",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasTeamSessionsOnly",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isWorkOnlyOrganisation",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teams",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxNumberOfOneToOneSessions",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxNumberOfOneToOneSessionsForGuests",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxNumberOfGuestsPerUser",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxNumberOfPublicClasses",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxNumberOfWorkshops",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "monthlyOneToOneSessionLimit",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "yearlyOneToOneSessionLimit",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oneToOneSessionsRenewalPeriod",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oneToOneSessionsForGuestsRenewalPeriod",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oneToOneRenewalDate",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publicClassesRenewalDate",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "services",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasDNAChargeEnabled",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasPAYGEnabled",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accessCareerCoaching",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "OrganisationSettings",
  "kind": "LinkedField",
  "name": "settings",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "crisisSupportEnabled",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "OrganisationGroup",
  "kind": "LinkedField",
  "name": "organisationGroup",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "OrganisationInGroup",
      "kind": "LinkedField",
      "name": "organisations",
      "plural": true,
      "selections": [
        (v7/*: any*/),
        (v10/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasBookedSessions",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "SessionAllowance",
  "kind": "LinkedField",
  "name": "sessionAllowance",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "oneToOneSessions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "coachingSessions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "therapySessions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publicClassSessions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "workshopSessions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "activeCareSessions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OrganisationPeriodAllowanceLimits",
      "kind": "LinkedField",
      "name": "organisationPeriodAllowanceLimits",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "monthlyLimit",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "monthlyRemaining",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "monthlyResetDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "monthlyUsed",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "yearlyLimit",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "yearlyRemaining",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "yearlyResetDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "yearlyUsed",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasActiveCoaching",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasActiveTherapy",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slackUserId",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slackTeamId",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSlackPaired",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slackIntegrationId",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasRequiredSlackScopes",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slackIntegrationMode",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "languages",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profileImage",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "verificationHash",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "personalEmail",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentServicePaymentMethodId",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "surname",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "organisationTeam",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasEnrolledMfa",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasCompletedOnboarding",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasCompletedWorkOnboarding",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "surveyEmployeeNPSPendingSubmissionId",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sessionId",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "concreteType": "ClinicalProfile",
  "kind": "LinkedField",
  "name": "clinicalProfile",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "image",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "surveyProfessionalNPSPendingSubmissionId",
  "storageKey": null
},
v58 = [
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "submissionId",
    "storageKey": null
  }
],
v59 = {
  "alias": null,
  "args": null,
  "concreteType": "VIPTrialSurveySubmissions",
  "kind": "LinkedField",
  "name": "vipTrialSurveySubmissions",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "VIPTrialSurvey",
      "kind": "LinkedField",
      "name": "gettingStartedSurveySubmission",
      "plural": false,
      "selections": (v58/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "VIPTrialSurvey",
      "kind": "LinkedField",
      "name": "followUpSurveySubmission",
      "plural": false,
      "selections": (v58/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gender",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "country",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "region",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "preferredLanguage",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "marketingOptIn",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phone",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dateOfBirth",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "apartment",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "streetAddress",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timezone",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zipCode",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "concreteType": "UserSettings",
  "kind": "LinkedField",
  "name": "settings",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allowDataProcessing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasGivenDataProcessingConsent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasGivenSessionSummarisationConsent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAcceptedTermsAndConditions",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "concreteType": "CareTypeAvailable",
  "kind": "LinkedField",
  "name": "careTypesAvailable",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "careType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isRecommended",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "token",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "religion",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sexualOrientation",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ethnicity",
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "concreteType": "MaxNumberOfServices",
  "kind": "LinkedField",
  "name": "maxNumberOfServices",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasUnlimitedSessions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasUnlimitedCoachingSessions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasUnlimitedTherapySessions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasSplitAllocation",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasTherapyOnlyAllocation",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasCoachingOnlyAllocation",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numberOfWorkshops",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numberOfOneToOneSessions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numberOfPublicClasses",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numberOfTherapySessions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numberOfCoachingSessions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numberOfSessionsForActiveCare",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserDataContextQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Organisation",
                "kind": "LinkedField",
                "name": "organisation",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OrganisationPlan",
                    "kind": "LinkedField",
                    "name": "plan",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      (v26/*: any*/),
                      (v27/*: any*/),
                      (v10/*: any*/),
                      (v5/*: any*/),
                      (v28/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v29/*: any*/)
                ],
                "storageKey": null
              },
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              (v43/*: any*/),
              (v44/*: any*/),
              (v7/*: any*/),
              (v10/*: any*/),
              (v45/*: any*/),
              (v46/*: any*/),
              (v47/*: any*/),
              (v48/*: any*/),
              (v49/*: any*/),
              (v50/*: any*/),
              (v51/*: any*/),
              (v52/*: any*/),
              (v53/*: any*/),
              (v54/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SurveyEmployeePostSessionSatisfaction",
                "kind": "LinkedField",
                "name": "surveyEmployeePostSessionSatisfaction",
                "plural": false,
                "selections": [
                  (v55/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "professional",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v56/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v57/*: any*/),
              (v59/*: any*/),
              (v60/*: any*/),
              (v5/*: any*/),
              (v61/*: any*/),
              (v62/*: any*/),
              (v63/*: any*/),
              (v64/*: any*/),
              (v65/*: any*/),
              (v66/*: any*/),
              (v67/*: any*/),
              (v68/*: any*/),
              (v69/*: any*/),
              (v70/*: any*/),
              (v71/*: any*/),
              (v72/*: any*/),
              (v73/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "DeviceToken",
                "kind": "LinkedField",
                "name": "deviceTokens",
                "plural": true,
                "selections": [
                  (v74/*: any*/)
                ],
                "storageKey": null
              },
              (v75/*: any*/),
              (v76/*: any*/),
              (v77/*: any*/),
              (v78/*: any*/)
            ],
            "type": "User",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "UserDataContextQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Organisation",
                "kind": "LinkedField",
                "name": "organisation",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OrganisationPlan",
                    "kind": "LinkedField",
                    "name": "plan",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      (v26/*: any*/),
                      (v27/*: any*/),
                      (v10/*: any*/),
                      (v5/*: any*/),
                      (v28/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v29/*: any*/)
                ],
                "storageKey": null
              },
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              (v43/*: any*/),
              (v44/*: any*/),
              (v7/*: any*/),
              (v10/*: any*/),
              (v45/*: any*/),
              (v46/*: any*/),
              (v47/*: any*/),
              (v48/*: any*/),
              (v49/*: any*/),
              (v50/*: any*/),
              (v51/*: any*/),
              (v52/*: any*/),
              (v53/*: any*/),
              (v54/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SurveyEmployeePostSessionSatisfaction",
                "kind": "LinkedField",
                "name": "surveyEmployeePostSessionSatisfaction",
                "plural": false,
                "selections": [
                  (v55/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "professional",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v56/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v57/*: any*/),
              (v59/*: any*/),
              (v60/*: any*/),
              (v5/*: any*/),
              (v61/*: any*/),
              (v62/*: any*/),
              (v63/*: any*/),
              (v64/*: any*/),
              (v65/*: any*/),
              (v66/*: any*/),
              (v67/*: any*/),
              (v68/*: any*/),
              (v69/*: any*/),
              (v70/*: any*/),
              (v71/*: any*/),
              (v72/*: any*/),
              (v73/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "DeviceToken",
                "kind": "LinkedField",
                "name": "deviceTokens",
                "plural": true,
                "selections": [
                  (v74/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              (v75/*: any*/),
              (v76/*: any*/),
              (v77/*: any*/),
              (v78/*: any*/)
            ],
            "type": "User",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "72eb030a9f1427abc0e992c50007ed18",
    "id": null,
    "metadata": {},
    "name": "UserDataContextQuery",
    "operationKind": "query",
    "text": "query UserDataContextQuery {\n  viewer {\n    __typename\n    ... on User {\n      detectedCountryCode\n      sessionPriceString\n      dnaSessionPriceString\n      lastThreadFeedbackDate\n      lastInsightFeedbackDate\n      guestInformation {\n        dependeeName\n        dependeeSurname\n        dependeeEmail\n        status\n        switchToPersonalPlanScheduledFor\n      }\n      organisation {\n        id\n        hasTeamSessionsOnly\n        isWorkOnlyOrganisation\n        name\n        teams\n        plan {\n          type\n          maxNumberOfOneToOneSessions\n          maxNumberOfOneToOneSessionsForGuests\n          maxNumberOfGuestsPerUser\n          maxNumberOfPublicClasses\n          maxNumberOfWorkshops\n          monthlyOneToOneSessionLimit\n          yearlyOneToOneSessionLimit\n          oneToOneSessionsRenewalPeriod\n          oneToOneSessionsForGuestsRenewalPeriod\n          endDate\n          oneToOneRenewalDate\n          publicClassesRenewalDate\n          services\n          hasDNAChargeEnabled\n          hasPAYGEnabled\n          name\n          status\n          accessCareerCoaching\n          id\n        }\n        settings {\n          crisisSupportEnabled\n        }\n      }\n      organisationGroup {\n        organisations {\n          id\n          name\n        }\n      }\n      hasBookedSessions\n      sessionAllowance {\n        oneToOneSessions\n        coachingSessions\n        therapySessions\n        publicClassSessions\n        workshopSessions\n        activeCareSessions\n        organisationPeriodAllowanceLimits {\n          monthlyLimit\n          monthlyRemaining\n          monthlyResetDate\n          monthlyUsed\n          yearlyLimit\n          yearlyRemaining\n          yearlyResetDate\n          yearlyUsed\n        }\n      }\n      hasActiveCoaching\n      hasActiveTherapy\n      createdAt\n      slackUserId\n      slackTeamId\n      isSlackPaired\n      slackIntegrationId\n      hasRequiredSlackScopes\n      slackIntegrationMode\n      role\n      languages\n      email\n      id\n      name\n      profileImage\n      verificationHash\n      personalEmail\n      paymentServicePaymentMethodId\n      surname\n      organisationTeam\n      hasEnrolledMfa\n      hasCompletedOnboarding\n      hasCompletedWorkOnboarding\n      surveyEmployeeNPSPendingSubmissionId\n      surveyEmployeePostSessionSatisfaction {\n        sessionId\n        professional {\n          name\n          clinicalProfile {\n            image\n          }\n          id\n        }\n      }\n      surveyProfessionalNPSPendingSubmissionId\n      vipTrialSurveySubmissions {\n        gettingStartedSurveySubmission {\n          status\n          submissionId\n        }\n        followUpSurveySubmission {\n          status\n          submissionId\n        }\n      }\n      gender\n      status\n      city\n      country\n      region\n      preferredLanguage\n      marketingOptIn\n      phone\n      dateOfBirth\n      apartment\n      streetAddress\n      timezone\n      zipCode\n      settings {\n        allowDataProcessing\n        hasGivenDataProcessingConsent\n        hasGivenSessionSummarisationConsent\n        hasAcceptedTermsAndConditions\n      }\n      careTypesAvailable {\n        careType\n        isRecommended\n      }\n      deviceTokens {\n        token\n        id\n      }\n      religion\n      sexualOrientation\n      ethnicity\n      maxNumberOfServices {\n        hasUnlimitedSessions\n        hasUnlimitedCoachingSessions\n        hasUnlimitedTherapySessions\n        hasSplitAllocation\n        hasTherapyOnlyAllocation\n        hasCoachingOnlyAllocation\n        numberOfWorkshops\n        numberOfOneToOneSessions\n        numberOfPublicClasses\n        numberOfTherapySessions\n        numberOfCoachingSessions\n        numberOfSessionsForActiveCare\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a3822d1dc83151e03e9e5d63aadeeb83";

export default node;
